var SHARP_YACIFBI = {
  name: "SHARP YACIFBI",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [23,1,6,228,2,178,1,238,2,16,6,123,35,24,17,254,2,134,77,236,2,157,155,237,2,0,0,47,127,255,255,183,98,186,255,191,255,184,75,223,255,255,234,236,127,255,253,255,168,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,129,35,20,17,223,2,178,1,234,2,17,6,239,2,145,77,224,2,155,155,245,2,0,0,149,42,170,170,170,169,42,169,74,148,73,82,85,85,74,170,170,170,148,134,84,170,170,170,170,164,170,164,149,40,170,170,170,170,170,170,170,146,160,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,225,2,173,1,123,35,21,17,238,2,16,6,243,2,145,77,234,2,160,155,242,2,0,0,78,124,255,249,63,51,152,147,147,254,127,254,76,133,57,243,255,228,252,147,152,255,255,255,254,96,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,225,2,176,1,236,2,14,6,123,35,27,17,247,2,142,77,235,2,159,155,240,2,0,0,46,253,255,235,246,236,87,95,247,255,250,132,187,247,255,175,213,216,255,255,255,251,96,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,224,2,175,1,229,2,16,6,125,35,30,17,245,2,145,77,230,2,157,155,243,2,0,0,46,250,255,245,251,118,43,175,251,255,246,161,46,250,255,245,250,187,31,255,255,255,172,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,150,35,19,17,233,2,173,1,239,2,12,6,1,3,121,77,234,2,167,155,247,2,0,0,149,42,170,85,85,84,149,84,165,74,36,169,42,170,165,85,85,85,73,33,149,42,170,85,85,84,149,84,146,165,21,85,85,85,85,85,85,82,74,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,222,2,175,1,130,35,27,17,231,2,27,6,246,2,145,77,224,2,160,155,224,2,0,0,78,124,207,254,79,204,230,36,228,255,159,255,146,72,83,159,51,255,147,242,78,99,255,255,255,252,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,149,35,25,17,221,2,174,1,233,2,23,6,5,3,145,77,249,2,161,155,237,2,0,0,149,42,169,42,170,170,74,170,82,165,18,84,149,85,82,170,170,170,170,134,84,170,164,170,170,169,42,169,37,74,42,170,170,170,170,170,170,165,72,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,225,2,171,1,125,35,22,17,235,2,15,6,244,2,148,77,239,2,159,155,244,2,0,0,78,124,147,255,147,243,57,137,57,63,231,255,231,133,57,242,79,254,79,201,57,143,255,255,255,204,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,150,35,251,16,221,2,175,1,253,2,25,6,249,2,140,77,247,2,140,155,235,2,0,0,149,42,170,149,85,84,149,84,165,74,36,169,42,170,165,85,85,85,74,134,84,170,170,85,85,82,85,82,74,148,85,85,85,85,85,85,85,73,72,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,224,2,170,1,147,35,30,17,230,2,19,6,233,2,148,77,243,2,162,155,224,2,0,0,78,124,231,254,79,204,230,36,228,255,159,255,147,133,57,243,159,249,63,36,230,63,255,255,255,146,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,146,35,22,17,222,2,174,1,232,2,23,6,241,2,141,77,242,2,161,155,225,2,0,0,149,42,169,74,170,170,74,170,82,165,18,84,149,85,82,170,170,170,169,67,42,85,82,149,85,84,149,84,146,165,21,85,85,85,85,85,85,82,146,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,146,35,31,17,221,2,156,1,228,2,23,6,238,2,145,77,245,2,165,155,225,2,0,0,149,42,164,165,85,85,37,85,41,82,137,42,74,170,169,85,85,85,74,80,202,149,82,82,170,170,146,170,146,84,162,170,170,170,170,170,170,170,146,65,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,221,2,172,1,123,35,18,17,235,2,23,6,242,2,139,77,240,2,137,155,222,2,0,0,78,127,39,254,79,204,230,36,228,255,159,255,201,133,57,252,159,249,63,36,230,63,255,255,254,73,32,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,222,2,177,1,125,35,20,17,233,2,28,6,243,2,142,77,243,2,158,155,233,2,0,0,78,124,201,255,147,243,57,137,57,63,231,255,228,152,83,159,50,127,228,252,147,152,255,255,255,255,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,151,35,29,17,224,2,152,1,227,2,17,6,236,2,137,77,224,2,156,155,249,2,0,0,149,42,169,37,85,85,37,85,41,82,137,42,74,170,169,85,85,85,85,33,149,42,169,37,85,85,37,85,36,169,69,85,85,85,85,85,85,84,170,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [23,1,6,225,2,174,1,234,2,25,6,128,35,25,17,244,2,147,77,228,2,158,155,245,2,0,0,46,191,255,235,246,236,87,95,247,255,246,132,186,255,255,175,213,216,255,255,251,255,96,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [23,1,6,161,35,26,17,222,2,169,1,234,2,19,6,246,2,145,77,223,2,167,155,247,2,0,0,149,37,82,170,170,170,74,170,82,165,18,84,149,85,82,170,170,170,146,144,202,146,169,85,85,85,37,85,36,169,69,85,85,85,85,84,170,170,82,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [23,1,6,234,2,174,1,128,35,19,17,240,2,2,6,245,2,148,77,245,2,129,155,248,2,0,0,78,79,159,255,63,51,152,147,147,254,127,255,146,20,228,249,255,243,242,78,99,255,255,231,252,152,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [23,1,6,153,35,18,17,222,2,179,1,229,2,28,6,245,2,145,77,229,2,121,155,243,2,0,0,149,37,82,85,85,85,37,85,41,82,137,42,74,170,169,85,85,85,74,72,101,73,84,149,85,85,73,85,73,42,81,85,85,85,85,85,42,170,146,80,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [23,1,6,223,2,178,1,233,2,18,6,153,35,20,17,244,2,148,77,224,2,168,155,222,2,0,0,46,191,127,245,251,118,43,175,251,255,250,161,46,191,127,245,250,187,31,255,255,127,244,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [23,1,6,120,35,20,17,223,2,177,1,235,2,23,6,247,2,137,77,223,2,149,155,226,2,0,0,149,37,82,149,85,85,37,85,41,82,137,42,74,170,169,85,85,85,73,36,50,164,170,82,170,170,164,170,164,149,40,170,170,170,170,170,149,85,74,144,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [23,1,6,146,35,23,17,221,2,173,1,230,2,26,6,246,2,147,77,239,2,161,155,226,2,0,0,149,37,84,149,85,85,37,85,41,82,137,42,74,170,169,85,85,85,85,67,42,74,169,42,170,170,74,170,73,82,138,170,170,170,170,169,85,85,41,4],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [23,1,6,121,35,23,17,224,2,180,1,230,2,19,6,238,2,146,77,245,2,162,155,226,2,0,0,149,37,82,74,170,170,146,170,148,169,68,149,37,85,84,170,170,170,165,80,202,146,169,37,85,85,73,85,73,42,81,85,85,85,85,85,42,170,146,144,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [23,1,6,122,35,21,17,223,2,179,1,233,2,28,6,250,2,145,77,244,2,163,155,224,2,0,0,149,37,85,74,170,170,74,170,82,165,18,84,149,85,82,170,170,170,165,67,42,74,170,149,85,84,149,84,146,165,21,85,85,85,85,82,170,170,146,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [23,1,6,221,2,171,1,150,35,19,17,234,2,27,6,246,2,147,77,241,2,129,155,222,2,0,0,78,79,57,255,147,243,57,137,57,63,231,255,228,225,78,79,57,255,147,242,78,99,255,255,231,249,146,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [23,1,6,222,2,159,1,159,35,20,17,232,2,28,6,240,2,141,77,246,2,156,155,222,2,0,0,78,79,153,255,147,243,57,137,57,63,231,255,249,133,57,62,103,254,79,201,57,143,255,255,159,242,72,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [23,1,6,153,35,20,17,223,2,177,1,232,2,27,6,242,2,110,77,249,2,162,155,224,2,0,0,149,37,82,82,170,170,146,170,148,169,68,149,37,85,84,170,170,170,165,40,101,73,84,148,170,170,164,170,164,149,40,170,170,170,170,170,149,85,73,36,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [23,1,6,123,35,21,17,223,2,172,1,234,2,27,6,240,2,146,77,247,2,159,155,251,2,0,0,149,37,85,37,85,85,37,85,41,82,137,42,74,170,169,85,85,85,82,80,202,146,170,146,170,170,146,170,146,84,162,170,170,170,170,170,85,85,85,4],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [23,1,6,222,2,155,1,233,2,22,6,125,35,22,17,246,2,152,77,249,2,171,155,247,2,0,0,46,189,175,253,126,221,138,235,254,255,253,88,75,175,107,255,95,171,177,255,255,247,251,193,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [23,1,6,152,35,31,17,222,2,177,1,227,2,28,6,239,2,148,77,224,2,160,155,240,2,0,0,149,37,84,146,170,170,146,170,148,169,68,149,37,85,84,170,170,170,170,144,202,146,170,73,85,85,73,85,73,42,81,85,85,85,85,85,42,170,165,65,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [23,1,6,224,2,179,1,239,2,28,6,135,35,29,17,245,2,150,77,222,2,164,155,247,2,0,0,46,223,255,235,246,236,87,95,247,255,246,132,187,127,255,175,213,216,255,255,250,255,88,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [23,1,6,155,35,29,17,222,2,173,1,229,2,28,6,239,2,156,77,223,2,177,155,247,2,0,0,149,41,82,170,170,170,74,170,82,165,18,84,149,85,82,170,170,170,146,144,202,148,169,85,85,85,37,85,36,169,69,85,85,85,85,84,149,85,36,160,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [23,1,6,222,2,174,1,128,35,33,17,226,2,23,6,249,2,154,77,224,2,165,155,223,2,0,0,78,103,159,254,79,204,230,36,228,255,159,255,228,133,57,158,127,249,63,36,230,63,255,254,79,252,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [23,1,6,170,35,249,16,222,2,176,1,247,2,28,6,244,2,149,77,223,2,165,155,222,2,0,0,149,41,82,85,85,85,37,85,41,82,137,42,74,170,169,85,85,85,74,72,101,74,84,149,85,85,73,85,73,42,81,85,85,85,85,85,37,85,74,144,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [23,1,6,223,2,179,1,230,2,27,6,124,35,28,17,241,2,151,77,226,2,163,155,227,2,0,0,46,223,127,245,251,118,43,175,251,255,250,161,46,223,127,245,250,187,31,255,255,95,237,4],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [23,1,6,179,35,34,17,222,2,179,1,225,2,19,6,240,2,147,77,224,2,167,155,224,2,0,0,149,41,82,149,85,85,37,85,41,82,137,42,74,170,169,85,85,85,73,36,50,165,42,82,170,170,164,170,164,149,40,170,170,170,170,170,146,170,164,164,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [23,1,6,150,35,28,17,222,2,176,1,228,2,27,6,239,2,146,77,246,2,154,155,223,2,0,0,149,41,84,149,85,85,37,85,41,82,137,42,74,170,169,85,85,85,85,67,42,82,169,42,170,170,74,170,73,82,138,170,170,170,170,169,42,170,164,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [23,1,6,223,2,179,1,171,35,31,17,228,2,23,6,236,2,141,77,240,2,136,155,225,2,0,0,78,103,36,255,228,252,206,98,78,79,249,255,249,225,78,103,36,255,228,252,147,152,255,255,249,63,153,32,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [23,1,6,221,2,180,1,230,2,27,6,157,35,28,17,254,2,136,77,238,2,154,155,225,2,0,0,46,223,191,245,251,118,43,175,251,255,251,132,187,126,255,215,234,236,127,255,253,127,170,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [23,1,6,150,35,5,17,224,2,173,1,238,2,18,6,245,2,152,77,242,2,164,155,225,2,0,0,149,41,82,165,85,85,37,85,41,82,137,42,74,170,169,85,85,85,73,80,202,148,169,82,170,170,146,170,146,84,162,170,170,170,170,170,74,170,146,72,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [23,1,6,153,35,25,17,223,2,175,1,233,2,26,6,248,2,148,77,241,2,164,155,245,2,0,0,149,41,84,165,85,85,37,85,41,82,137,42,74,170,169,85,85,85,84,161,149,41,84,165,85,85,37,85,36,169,69,85,85,85,85,84,149,85,85,4],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [23,1,6,222,2,180,1,124,35,29,17,229,2,28,6,244,2,156,77,239,2,172,155,247,2,0,0,78,103,38,127,228,252,206,98,78,79,249,255,249,152,83,153,201,159,249,63,36,230,63,255,254,79,231,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [23,1,6,222,2,167,1,232,2,28,6,149,35,21,17,11,3,144,77,237,2,150,155,247,2,0,0,46,223,95,250,253,187,21,215,253,255,253,97,46,223,95,250,253,93,143,255,255,175,247,4],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [23,1,6,222,2,161,1,232,2,28,6,130,35,18,17,240,2,137,77,247,2,163,155,243,2,0,0,46,221,175,253,126,221,138,235,254,255,253,88,75,183,107,255,95,171,177,255,255,245,253,112,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [23,1,6,121,35,19,17,222,2,177,1,231,2,28,6,243,2,148,77,227,2,151,155,3,3,0,0,149,41,84,146,170,170,146,170,148,169,68,149,37,85,84,170,170,170,170,144,202,148,170,73,85,85,73,85,73,42,81,85,85,85,85,85,37,85,84,160,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,174,1,146,35,20,17,236,2,19,6,244,2,141,77,224,2,161,155,223,2,0,0,78,73,255,255,63,51,152,147,147,254,127,255,50,20,228,159,255,243,242,78,99,255,255,230,127,200,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,125,35,22,17,224,2,178,1,236,2,21,6,250,2,121,77,227,2,157,155,226,2,0,0,149,36,169,85,85,85,74,170,82,165,18,84,149,85,82,170,170,170,146,144,202,146,84,170,170,170,165,85,36,169,69,85,85,85,85,84,165,85,42,65,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,178,1,126,35,25,17,235,2,24,6,246,2,133,77,222,2,164,155,225,2,0,0,78,73,231,255,207,204,230,36,228,255,159,255,228,133,57,39,159,255,63,36,230,63,255,254,103,243,32,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,179,1,152,35,24,17,231,2,25,6,249,2,144,77,223,2,163,155,225,2,0,0,78,73,201,255,243,243,57,137,57,63,231,255,230,72,83,146,114,127,252,252,147,152,255,255,249,159,147,32,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,180,1,233,2,26,6,149,35,20,17,241,2,134,77,223,2,157,155,223,2,0,0,46,175,191,253,251,118,43,175,251,255,250,161,46,175,191,253,250,187,31,255,255,111,245,4],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,222,2,179,1,229,2,25,6,124,35,23,17,250,2,131,77,226,2,155,155,226,2,0,0,46,174,223,254,253,187,21,215,253,255,250,168,75,171,183,255,191,87,99,255,255,237,251,80,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,126,35,23,17,223,2,178,1,228,2,27,6,244,2,138,77,239,2,154,155,226,2,0,0,149,36,170,74,170,170,165,85,41,82,137,42,74,170,169,85,85,85,85,67,42,73,84,149,85,85,74,170,73,82,138,170,170,170,170,169,74,170,146,65,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,224,2,132,1,150,35,11,17,233,2,25,6,236,2,138,77,244,2,151,155,225,2,0,0,78,73,201,63,252,252,206,98,78,79,249,255,249,225,78,73,201,63,252,252,147,152,255,255,249,159,146,72,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,127,35,25,17,223,2,179,1,235,2,26,6,237,2,139,77,248,2,159,155,243,2,0,0,149,36,170,165,85,85,74,170,82,165,18,84,149,85,82,170,170,170,165,67,42,73,85,74,170,170,149,84,146,165,21,85,85,85,85,82,149,85,84,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,126,35,16,17,223,2,178,1,236,2,18,6,248,2,150,77,236,2,165,155,239,2,0,0,149,36,169,82,170,170,165,85,41,82,137,42,74,170,169,85,85,85,73,80,202,146,84,169,85,85,82,170,146,84,162,170,170,170,170,170,82,170,149,65,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,151,35,26,17,224,2,167,1,232,2,16,6,250,2,132,77,15,3,149,155,242,2,0,0,149,36,170,82,170,170,165,85,41,82,137,42,74,170,169,85,85,85,84,161,149,36,170,82,170,170,165,85,36,169,69,85,85,85,85,84,165,85,74,130],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,153,35,27,17,224,2,176,1,230,2,19,6,239,2,139,77,249,2,162,155,248,2,0,0,149,36,169,41,85,85,82,170,148,169,68,149,37,85,84,170,170,170,165,40,101,73,42,74,85,85,84,170,164,149,40,170,170,170,170,170,148,170,164,168,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,224,2,181,1,233,2,25,6,123,35,17,17,240,2,142,77,245,2,151,155,239,2,0,0,46,175,175,254,253,187,21,215,253,255,253,97,46,175,175,254,253,93,143,255,255,183,251,4],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,122,35,23,17,223,2,178,1,229,2,26,6,224,2,148,77,237,2,155,155,239,2,0,0,149,36,169,73,85,85,82,170,148,169,68,149,37,85,84,170,170,170,164,148,50,164,149,41,42,170,170,85,82,74,148,85,85,85,85,85,74,85,82,148,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,178,1,121,35,23,17,232,2,17,6,245,2,134,77,229,2,145,155,243,2,0,0,78,73,228,159,252,252,206,98,78,79,249,255,255,33,78,73,228,159,252,252,147,152,255,255,249,159,201,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,128,35,22,17,225,2,181,1,229,2,27,6,246,2,138,77,230,2,148,155,245,2,0,0,169,42,170,170,170,170,85,82,149,40,170,170,170,169,85,85,85,82,144,212,149,85,85,85,85,42,169,37,74,42,170,170,170,170,170,170,169,40,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,224,2,181,1,149,35,23,17,231,2,26,6,241,2,146,77,227,2,153,155,238,2,0,0,114,124,255,252,252,206,99,255,249,255,249,50,23,39,207,255,207,201,57,143,255,255,255,146,96,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,223,2,182,1,146,35,26,17,228,2,27,6,244,2,141,77,227,2,166,155,225,2,0,0,114,126,127,252,252,206,99,255,249,255,254,72,92,159,159,255,63,36,230,63,255,255,255,200,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,223,2,183,1,129,35,31,17,231,2,27,6,223,2,148,77,229,2,155,155,228,2,0,0,114,124,159,255,63,51,152,255,254,127,254,100,133,201,242,127,252,252,147,152,255,255,255,249,200,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,151,35,20,17,225,2,182,1,246,2,26,6,240,2,112,77,225,2,130,155,226,2,0,0,169,42,170,85,85,85,42,169,74,148,85,85,85,84,170,170,170,169,36,53,37,85,74,170,170,165,85,36,169,69,85,85,85,85,85,85,85,41,4],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,153,35,31,17,224,2,179,1,232,2,25,6,254,2,132,77,225,2,154,155,224,2,0,0,169,42,165,42,170,170,149,84,165,74,42,170,170,170,85,85,85,82,73,13,73,85,41,85,85,84,170,164,149,40,170,170,170,170,170,170,170,146,144,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,224,2,180,1,149,35,31,17,245,2,26,6,253,2,142,77,18,3,156,155,228,2,0,0,114,126,79,255,63,51,152,255,254,127,255,225,114,126,79,255,63,36,230,63,255,255,255,146,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,128,35,18,17,225,2,176,1,251,2,26,6,242,2,141,77,255,2,161,155,226,2,0,0,169,42,164,149,85,85,74,170,82,165,21,85,85,85,42,170,170,169,84,53,37,84,146,170,170,169,85,73,42,81,85,85,85,85,85,85,85,41,32,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,122,35,19,17,226,2,177,1,233,2,29,6,241,2,144,77,253,2,143,155,222,2,0,0,169,42,170,149,85,85,42,169,74,148,85,85,85,84,170,170,170,169,80,212,149,85,74,170,170,149,84,146,165,21,85,85,85,85,85,85,84,146,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,128,35,26,17,224,2,179,1,227,2,26,6,243,2,137,77,240,2,153,155,225,2,0,0,169,42,165,74,170,170,149,84,165,74,42,170,170,170,85,85,85,82,84,53,37,84,169,85,85,82,170,146,84,162,170,170,170,170,170,170,170,73,32,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,130,35,22,17,224,2,181,1,235,2,29,6,246,2,131,77,238,2,161,155,248,2,0,0,169,42,169,74,170,170,149,84,165,74,42,170,170,170,85,85,85,85,40,106,74,170,82,170,170,165,85,36,169,69,85,85,85,85,85,85,85,84,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,120,35,20,17,226,2,180,1,252,2,28,6,241,2,139,77,248,2,158,155,242,2,0,0,169,42,164,165,85,85,74,170,82,165,21,85,85,85,42,170,170,169,74,26,146,170,74,85,85,84,170,164,149,40,170,170,170,170,170,170,170,149,65,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,121,35,28,17,223,2,180,1,233,2,28,6,245,2,147,77,247,2,155,155,239,2,0,0,169,42,170,74,170,170,149,84,165,74,42,170,170,170,85,85,85,84,148,53,37,85,73,85,85,82,170,146,84,162,170,170,170,170,170,170,170,149,4],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,155,35,20,17,224,2,179,1,233,2,26,6,249,2,137,77,248,2,149,155,246,2,0,0,169,42,165,37,85,85,74,170,82,165,21,85,85,85,42,170,170,169,37,13,73,85,41,42,170,170,85,82,74,148,85,85,85,85,85,85,85,73,80,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,156,35,20,17,228,2,181,1,235,2,29,6,242,2,135,77,225,2,148,155,240,2,0,0,169,42,169,37,85,85,74,170,82,165,21,85,85,85,42,170,170,170,164,53,37,85,36,170,170,169,85,73,42,81,85,85,85,85,85,85,85,82,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [23,1,6,222,2,176,1,126,35,47,17,233,2,27,6,243,2,125,77,224,2,172,155,235,2,0,0,114,79,255,252,252,206,99,255,249,255,252,200,92,147,255,255,63,36,230,63,255,254,127,146,96,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [23,1,6,142,35,19,17,226,2,181,1,230,2,27,6,245,2,140,77,224,2,164,155,224,2,0,0,169,37,82,170,170,170,149,84,165,74,42,170,170,170,85,85,85,82,82,26,146,85,42,170,170,169,85,73,42,81,85,85,85,85,85,42,170,170,65,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [23,1,6,128,35,14,17,227,2,177,1,238,2,28,6,246,2,148,77,225,2,165,155,228,2,0,0,169,37,84,170,170,170,149,84,165,74,42,170,170,170,85,85,85,85,36,53,36,170,149,85,85,82,170,146,84,162,170,170,170,170,170,85,85,42,65,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [23,1,6,231,2,169,1,132,35,30,17,239,2,9,6,250,2,141,77,249,2,155,155,237,2,0,0,114,79,39,255,207,204,230,63,255,159,255,153,33,114,79,39,255,207,201,57,143,255,255,159,243,32,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [23,1,6,227,2,178,1,124,35,23,17,229,2,24,6,239,2,132,77,226,2,153,155,228,2,0,0,114,79,207,255,63,51,152,255,254,127,255,36,133,201,63,63,252,252,147,152,255,255,249,254,76,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [23,1,6,146,35,24,17,227,2,178,1,229,2,26,6,18,3,135,77,222,2,156,155,224,2,0,0,169,37,82,149,85,85,74,170,82,165,21,85,85,85,42,170,170,169,36,134,164,149,74,85,85,85,42,169,37,74,42,170,170,170,170,165,85,85,36,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [23,1,6,139,35,23,17,227,2,176,1,232,2,26,6,243,2,133,77,249,2,144,155,225,2,0,0,169,37,84,149,85,85,74,170,82,165,21,85,85,85,42,170,170,170,168,106,73,85,37,85,85,82,170,146,84,162,170,170,170,170,170,85,85,41,32,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [23,1,6,125,35,26,17,225,2,180,1,232,2,26,6,251,2,145,77,255,2,165,155,227,2,0,0,169,37,82,74,170,170,165,85,41,82,138,170,170,170,149,85,85,84,170,26,146,85,36,170,170,170,85,82,74,148,85,85,85,85,85,74,170,169,36,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [23,1,6,225,2,180,1,172,35,30,17,228,2,25,6,237,2,142,77,249,2,154,155,229,2,0,0,114,79,231,255,63,51,152,255,254,127,255,56,92,147,249,255,207,201,57,143,255,255,159,228,146,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [23,1,6,128,35,19,17,226,2,178,1,235,2,26,6,245,2,109,77,244,2,166,155,240,2,0,0,169,37,82,165,85,85,74,170,82,165,21,85,85,85,42,170,170,169,42,26,146,85,42,85,85,84,170,164,149,40,170,170,170,170,170,149,85,85,65,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [23,1,6,225,2,179,1,125,35,19,17,229,2,27,6,240,2,145,77,241,2,145,155,249,2,0,0,114,79,153,255,207,204,230,63,255,159,255,230,23,36,249,159,252,252,147,152,255,255,249,254,120,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [23,1,6,127,35,26,17,224,2,182,1,233,2,26,6,238,2,143,77,241,2,157,155,242,2,0,0,169,37,82,82,170,170,165,85,41,82,138,170,170,170,149,85,85,84,165,13,73,42,146,149,85,85,42,169,37,74,42,170,170,170,170,165,85,84,168,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [23,1,6,121,35,5,17,229,2,179,1,233,2,26,6,251,2,143,77,239,2,124,155,246,2,0,0,169,37,85,37,85,85,74,170,82,165,21,85,85,85,42,170,170,170,74,26,146,85,82,85,85,84,170,164,149,40,170,170,170,170,170,149,85,73,80,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [23,1,6,148,35,22,17,224,2,178,1,232,2,26,6,247,2,139,77,245,2,136,155,240,2,0,0,169,37,82,146,170,170,165,85,41,82,138,170,170,170,149,85,85,84,146,134,164,149,74,74,170,170,149,84,146,165,21,85,85,85,85,82,170,170,148,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [23,1,6,226,2,176,1,148,35,20,17,254,2,26,6,237,2,139,77,225,2,157,155,237,2,0,0,114,79,146,127,243,243,57,143,255,231,255,252,133,201,62,73,255,207,201,57,143,255,255,159,230,96,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [23,1,6,226,2,175,1,235,2,29,6,129,35,15,17,243,2,144,77,226,2,168,155,223,2,0,0,58,223,255,247,237,216,255,254,255,254,208,157,111,255,251,245,118,63,255,254,191,186,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [23,1,6,125,35,21,17,225,2,170,1,246,2,22,6,246,2,150,77,224,2,158,155,224,2,0,0,169,41,82,170,170,170,149,84,165,74,42,170,170,170,85,85,85,82,82,26,146,149,42,170,170,169,85,73,42,81,85,85,85,85,85,37,85,82,144,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [23,1,6,130,35,18,17,224,2,171,1,230,2,30,6,233,2,138,77,225,2,160,155,226,2,0,0,169,41,84,170,170,170,149,84,165,74,42,170,170,170,85,85,85,85,36,53,37,42,149,85,85,82,170,146,84,162,170,170,170,170,170,74,170,146,144,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [23,1,6,125,35,21,17,226,2,177,1,246,2,28,6,241,2,154,77,224,2,148,155,224,2,0,0,169,41,82,85,85,85,74,170,82,165,21,85,85,85,42,170,170,169,73,13,73,74,146,170,170,170,85,82,74,148,85,85,85,85,85,73,85,85,36,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [23,1,6,145,35,24,17,225,2,175,1,227,2,28,6,249,2,144,77,225,2,156,155,223,2,0,0,169,41,85,42,170,170,149,84,165,74,42,170,170,170,85,85,85,84,146,26,146,149,82,170,170,169,85,73,42,81,85,85,85,85,85,37,85,74,72,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [23,1,6,126,35,23,17,225,2,180,1,226,2,27,6,245,2,134,77,225,2,154,155,223,2,0,0,169,41,82,149,85,85,74,170,82,165,21,85,85,85,42,170,170,169,36,134,164,165,74,85,85,85,42,169,37,74,42,170,170,170,170,164,170,170,73,4],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [23,1,6,229,2,175,1,125,35,21,17,239,2,28,6,248,2,146,77,238,2,167,155,223,2,0,0,114,103,147,255,207,204,230,63,255,159,255,248,92,153,228,255,243,242,78,99,255,255,228,254,73,32,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [23,1,6,148,35,24,17,225,2,176,1,230,2,28,6,244,2,143,77,243,2,163,155,239,2,0,0,169,41,82,74,170,170,165,85,41,82,138,170,170,170,149,85,85,84,170,26,146,149,36,170,170,170,85,82,74,148,85,85,85,85,85,73,85,85,80,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [23,1,6,127,35,22,17,225,2,179,1,249,2,29,6,244,2,149,77,245,2,163,155,237,2,0,0,169,41,85,74,170,170,149,84,165,74,42,170,170,170,85,85,85,84,168,106,74,85,82,170,170,165,85,36,169,69,85,85,85,85,84,149,85,42,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [23,1,6,225,2,180,1,127,35,19,17,230,2,28,6,244,2,134,77,244,2,119,155,240,2,0,0,114,103,57,255,207,204,230,63,255,159,255,147,133,201,156,231,255,63,36,230,63,255,254,79,243,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [23,1,6,147,35,20,17,223,2,176,1,233,2,30,6,248,2,139,77,254,2,148,155,244,2,0,0,169,41,84,165,85,85,74,170,82,165,21,85,85,85,42,170,170,170,148,53,37,42,148,170,170,169,85,73,42,81,85,85,85,85,85,37,85,73,80,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [23,1,6,133,35,26,17,224,2,180,1,233,2,28,6,240,2,135,77,236,2,158,155,244,2,0,0,169,41,82,82,170,170,165,85,41,82,138,170,170,170,149,85,85,84,165,13,73,74,146,149,85,85,42,169,37,74,42,170,170,170,170,164,170,170,148,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [23,1,6,147,35,27,17,223,2,180,1,232,2,27,6,243,2,138,77,237,2,162,155,244,2,0,0,169,41,85,37,85,85,74,170,82,165,21,85,85,85,42,170,170,170,74,26,146,149,82,85,85,84,170,164,149,40,170,170,170,170,170,146,170,165,40,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [23,1,6,124,35,25,17,224,2,181,1,231,2,28,6,240,2,141,77,244,2,140,155,243,2,0,0,169,41,82,146,170,170,165,85,41,82,138,170,170,170,149,85,85,84,146,134,164,165,74,74,170,170,149,84,146,165,21,85,85,85,85,82,85,85,37,4],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [23,1,6,165,35,31,17,223,2,180,1,231,2,27,6,248,2,136,77,225,2,164,155,241,2,0,0,169,41,84,146,170,170,165,85,41,82,138,170,170,170,149,85,85,85,82,26,146,149,73,42,170,170,85,82,74,148,85,85,85,85,85,73,85,82,74,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,226,2,178,1,125,35,29,17,234,2,27,6,250,2,150,77,224,2,128,155,223,2,0,0,114,73,255,255,63,51,152,255,254,127,255,50,23,36,159,255,243,242,78,99,255,255,230,126,76,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,148,35,24,17,228,2,167,1,233,2,19,6,243,2,142,77,231,2,140,155,242,2,0,0,169,36,169,85,85,85,74,170,82,165,21,85,85,85,42,170,170,169,41,13,73,37,74,170,170,170,85,82,74,148,85,85,85,85,85,74,85,85,36,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,227,2,180,1,153,35,11,17,232,2,27,6,236,2,152,77,225,2,152,155,224,2,0,0,114,73,231,255,207,204,230,63,255,159,255,228,133,201,39,159,255,63,36,230,63,255,254,103,230,72,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,231,2,179,1,154,35,248,16,251,2,27,6,235,2,133,77,223,2,148,155,224,2,0,0,114,73,201,255,243,243,57,143,255,231,255,230,72,92,146,114,127,252,252,147,152,255,255,249,159,201,32,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,126,35,29,17,222,2,178,1,231,2,28,6,245,2,139,77,224,2,158,155,224,2,0,0,169,36,170,149,85,85,74,170,82,165,21,85,85,85,42,170,170,170,73,13,73,37,84,170,170,170,85,82,74,148,85,85,85,85,85,74,85,82,73,4],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,127,35,23,17,225,2,177,1,226,2,27,6,237,2,153,77,222,2,159,155,246,2,0,0,169,36,169,74,170,170,165,85,41,82,138,170,170,170,149,85,85,84,146,67,82,73,82,149,85,85,74,170,73,82,138,170,170,170,170,169,74,170,170,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,125,35,29,17,224,2,180,1,229,2,29,6,242,2,146,77,243,2,157,155,252,2,0,0,169,36,170,74,170,170,165,85,41,82,138,170,170,170,149,85,85,85,84,53,36,149,73,85,85,84,170,164,149,40,170,170,170,170,170,148,170,165,80,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,145,35,22,17,226,2,173,1,231,2,27,6,11,3,139,77,241,2,155,155,21,3,0,0,169,36,169,37,85,85,82,170,148,169,69,85,85,85,74,170,170,170,85,13,73,37,73,42,170,170,149,84,146,165,21,85,85,85,85,82,149,85,42,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,232,2,179,1,126,35,17,17,237,2,17,6,244,2,138,77,249,2,133,155,240,2,0,0,114,73,249,255,207,204,230,63,255,159,255,206,23,36,159,159,252,252,147,152,255,255,249,159,147,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,228,2,175,1,156,35,250,16,235,2,27,6,245,2,117,77,251,2,158,155,250,2,0,0,114,73,206,127,243,243,57,143,255,231,255,228,225,114,73,206,127,243,242,78,99,255,255,230,127,152,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,222,2,178,1,125,35,28,17,231,2,27,6,14,3,141,77,250,2,165,155,247,2,0,0,114,73,230,127,243,243,57,143,255,231,255,249,133,201,39,153,255,207,201,57,143,255,255,153,249,152,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,222,2,179,1,128,35,22,17,232,2,25,6,247,2,132,77,242,2,156,155,247,2,0,0,114,73,201,159,252,252,206,99,255,249,255,249,152,92,146,114,103,255,63,36,230,63,255,254,103,242,96,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,132,35,25,17,225,2,178,1,226,2,25,6,250,2,142,77,28,3,152,155,248,2,0,0,169,36,170,146,170,170,165,85,41,82,138,170,170,170,149,85,85,85,37,13,73,37,84,149,85,85,42,169,37,74,42,170,170,170,170,165,42,169,37,4],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,120,35,19,17,224,2,177,1,234,2,27,6,249,2,135,77,238,2,159,155,224,2,0,0,169,36,169,73,85,85,82,170,148,169,69,85,85,85,74,170,170,170,73,67,82,73,82,146,170,170,165,85,36,169,69,85,85,85,85,84,165,85,84,130],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,126,35,18,17,225,2,178,1,232,2,26,6,236,2,135,77,226,2,147,155,232,2,0,0,169,36,170,73,85,85,82,170,148,169,69,85,85,85,74,170,170,170,169,13,73,37,82,74,170,170,149,84,146,165,21,85,85,85,85,82,149,84,169,4],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [23,1,6,226,2,179,1,236,2,29,6,148,35,22,17,245,2,158,77,227,2,169,155,241,2,0,0,54,191,255,247,237,216,255,254,255,255,161,54,191,255,247,234,236,127,255,253,254,216,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [23,1,6,126,35,20,17,227,2,179,1,231,2,30,6,243,2,146,77,226,2,137,155,244,2,0,0,165,37,82,170,170,170,149,84,165,74,42,170,170,170,85,85,85,82,164,52,164,170,85,85,85,82,170,146,84,162,170,170,170,170,170,85,85,73,65,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [23,1,6,122,35,27,17,224,2,177,1,227,2,28,6,244,2,136,77,222,2,158,155,242,2,0,0,165,37,84,170,170,170,149,84,165,74,42,170,170,170,85,85,85,84,164,52,164,170,149,85,85,82,170,146,84,162,170,170,170,170,170,85,85,36,160,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [23,1,6,154,35,19,17,224,2,180,1,229,2,27,6,246,2,150,77,228,2,144,155,227,2,0,0,165,37,82,85,85,85,74,170,82,165,21,85,85,85,42,170,170,169,41,13,41,42,146,170,170,170,85,82,74,148,85,85,85,85,85,74,170,170,144,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [23,1,6,157,35,23,17,224,2,180,1,229,2,27,6,241,2,108,77,225,2,153,155,224,2,0,0,165,37,85,42,170,170,149,84,165,74,42,170,170,170,85,85,85,85,36,52,164,170,165,85,85,82,170,146,84,162,170,170,170,170,170,85,85,42,65,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [23,1,6,125,35,20,17,224,2,177,1,233,2,28,6,246,2,138,77,225,2,156,155,224,2,0,0,165,37,82,149,85,85,74,170,82,165,21,85,85,85,42,170,170,169,73,13,41,42,148,170,170,170,85,82,74,148,85,85,85,85,85,74,170,169,72,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [23,1,6,125,35,22,17,226,2,179,1,230,2,28,6,240,2,141,77,228,2,153,155,226,2,0,0,165,37,84,149,85,85,74,170,82,165,21,85,85,85,42,170,170,170,73,13,41,42,164,170,170,170,85,82,74,148,85,85,85,85,85,74,170,164,164,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [23,1,6,122,35,17,17,228,2,177,1,232,2,27,6,248,2,119,77,222,2,154,155,222,2,0,0,165,37,82,74,170,170,165,85,41,82,138,170,170,170,149,85,85,84,146,67,74,74,164,149,85,85,74,170,73,82,138,170,170,170,170,169,85,85,73,4],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [23,1,6,125,35,23,17,224,2,177,1,237,2,27,6,242,2,130,77,242,2,127,155,225,2,0,0,165,37,85,74,170,170,149,84,165,74,42,170,170,170,85,85,85,85,80,210,146,170,165,85,85,74,170,73,82,138,170,170,170,170,169,85,84,164,130],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [23,1,6,157,35,19,17,225,2,180,1,227,2,27,6,233,2,147,77,240,2,160,155,228,2,0,0,165,37,82,165,85,85,74,170,82,165,21,85,85,85,42,170,170,169,84,52,164,170,84,170,170,169,85,73,42,81,85,85,85,85,85,42,170,164,144,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [23,1,6,225,2,177,1,152,35,22,17,233,2,28,6,245,2,137,77,238,2,146,155,230,2,0,0,102,79,153,255,207,204,230,63,255,159,255,206,22,100,249,159,252,252,147,152,255,255,249,254,73,32,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [23,1,6,129,35,19,17,225,2,180,1,226,2,29,6,246,2,140,77,245,2,161,155,243,2,0,0,165,37,82,82,170,170,165,85,41,82,138,170,170,170,149,85,85,84,149,13,41,42,146,149,85,85,42,169,37,74,42,170,170,170,170,165,85,85,80,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [23,1,6,130,35,19,17,225,2,178,1,231,2,28,6,238,2,140,77,25,3,158,155,243,2,0,0,165,37,85,37,85,85,74,170,82,165,21,85,85,85,42,170,170,170,148,52,164,170,164,170,170,169,85,73,42,81,85,85,85,85,85,42,170,149,65,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [23,1,6,223,2,179,1,148,35,20,17,231,2,29,6,245,2,143,77,246,2,157,155,248,2,0,0,102,79,50,127,243,243,57,143,255,231,255,230,97,102,79,50,127,243,242,78,99,255,255,231,252,224,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [23,1,6,223,2,179,1,156,35,26,17,225,2,27,6,240,2,138,77,250,2,166,155,246,2,0,0,102,79,146,127,243,243,57,143,255,231,255,242,97,102,79,146,127,243,242,78,99,255,255,231,249,56,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,226,2,178,1,131,35,28,17,235,2,27,6,240,2,143,77,228,2,161,155,227,2,0,0,121,243,159,252,252,206,99,255,249,255,249,36,133,231,206,127,243,242,78,99,255,255,255,228,200,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [23,1,6,227,2,181,1,153,35,21,17,235,2,26,6,235,2,123,77,225,2,168,155,226,2,0,0,121,60,231,255,63,51,152,255,254,127,254,73,33,121,60,231,255,63,36,230,63,255,254,127,228,130],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [23,1,6,226,2,178,1,133,35,22,17,231,2,26,6,242,2,144,77,227,2,167,155,225,2,0,0,121,156,231,255,63,51,152,255,254,127,254,73,33,121,156,231,255,63,36,230,63,255,254,79,242,72,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,226,2,179,1,154,35,26,17,255,2,28,6,241,2,102,77,225,2,160,155,242,2,0,0,121,39,57,255,207,204,230,63,255,159,255,146,72,94,73,206,127,243,242,78,99,255,255,230,127,224,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,121,35,9,17,223,2,181,1,244,2,27,6,246,2,143,77,231,2,160,155,239,2,0,0,146,149,85,85,85,85,42,169,74,148,85,85,85,84,170,170,170,165,72,100,165,85,85,85,85,74,170,73,82,138,170,170,170,170,170,170,169,74,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,154,35,30,17,224,2,178,1,235,2,13,6,247,2,150,77,239,2,155,155,238,2,0,0,146,149,82,170,170,170,149,84,165,74,42,170,170,170,85,85,85,84,164,50,82,170,85,85,85,82,170,146,84,162,170,170,170,170,170,170,170,146,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,158,35,27,17,223,2,173,1,234,2,5,6,246,2,142,77,241,2,164,155,241,2,0,0,146,149,84,170,170,170,149,84,165,74,42,170,170,170,85,85,85,82,82,25,41,85,74,170,170,169,85,73,42,81,85,85,85,85,85,85,85,36,160,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,129,35,248,16,222,2,177,1,2,3,18,6,245,2,148,77,241,2,153,155,237,2,0,0,146,149,82,85,85,85,74,170,82,165,21,85,85,85,42,170,170,170,146,25,41,85,37,85,85,84,170,164,149,40,170,170,170,170,170,170,170,170,65,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,157,35,21,17,230,2,177,1,239,2,10,6,243,2,141,77,253,2,156,155,241,2,0,0,146,149,85,42,170,170,149,84,165,74,42,170,170,170,85,85,85,82,146,25,41,85,82,170,170,169,85,73,42,81,85,85,85,85,85,85,85,42,65,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,150,35,26,17,228,2,176,1,235,2,11,6,239,2,141,77,223,2,161,155,236,2,0,0,146,149,82,149,85,85,74,170,82,165,21,85,85,85,42,170,170,170,73,12,148,170,148,170,170,170,85,82,74,148,85,85,85,85,85,85,85,82,144,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,125,35,36,17,233,2,179,1,233,2,8,6,246,2,141,77,236,2,164,155,247,2,0,0,146,149,84,149,85,85,74,170,82,165,21,85,85,85,42,170,170,169,36,134,74,85,82,85,85,85,42,169,37,74,42,170,170,170,170,170,170,164,164,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,125,35,22,17,235,2,171,1,240,2,10,6,238,2,152,77,251,2,162,155,239,2,0,0,146,149,82,74,170,170,165,85,41,82,138,170,170,170,149,85,85,85,84,50,82,170,73,85,85,84,170,164,149,40,170,170,170,170,170,170,170,169,32,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,235,2,173,1,123,35,20,17,242,2,5,6,248,2,147,77,248,2,154,155,226,2,0,0,73,159,231,255,63,51,152,255,254,127,254,120,82,103,249,255,207,201,57,143,255,255,255,153,32,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,150,35,18,17,235,2,176,1,239,2,8,6,240,2,150,77,249,2,171,155,239,2,0,0,146,149,82,165,85,85,74,170,82,165,21,85,85,85,42,170,170,170,84,50,82,170,84,170,170,169,85,73,42,81,85,85,85,85,85,85,85,73,32,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,124,35,30,17,234,2,176,1,237,2,1,6,242,2,143,77,250,2,159,155,244,2,0,0,146,149,84,165,85,85,74,170,82,165,21,85,85,85,42,170,170,169,42,25,41,85,74,85,85,84,170,164,149,40,170,170,170,170,170,170,170,146,72,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,125,35,1,17,233,2,177,1,248,2,7,6,245,2,146,77,242,2,164,155,239,2,0,0,146,149,82,82,170,170,165,85,41,82,138,170,170,170,149,85,85,85,74,25,41,85,37,42,170,170,85,82,74,148,85,85,85,85,85,85,85,85,65,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,127,35,19,17,233,2,153,1,238,2,7,6,245,2,139,77,233,2,157,155,243,2,0,0,146,149,85,37,85,85,74,170,82,165,21,85,85,85,42,170,170,169,74,25,41,85,82,85,85,84,170,164,149,40,170,170,170,170,170,170,170,149,65,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,235,2,173,1,152,35,27,17,238,2,9,6,246,2,146,77,248,2,164,155,248,2,0,0,73,159,50,127,243,243,57,143,255,231,255,242,97,73,159,50,127,243,242,78,99,255,255,255,243,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [23,1,6,180,35,27,17,234,2,177,1,238,2,8,6,255,2,143,77,248,2,159,155,247,2,0,0,146,149,84,146,170,170,165,85,41,82,138,170,170,170,149,85,85,84,146,134,74,85,82,74,170,170,149,84,146,165,21,85,85,85,85,85,85,82,84,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [23,1,6,227,2,160,1,150,35,31,17,236,2,14,6,249,2,144,77,226,2,158,155,240,2,0,0,73,147,255,255,63,51,152,255,254,127,254,114,20,153,63,255,243,242,78,99,255,255,231,252,152,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [23,1,6,223,2,164,1,124,35,29,17,234,2,13,6,241,2,142,77,228,2,163,155,250,2,0,0,73,147,207,255,207,204,230,63,255,159,255,204,133,38,79,63,255,63,36,230,63,255,254,127,146,96,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [23,1,6,156,35,23,17,222,2,178,1,236,2,17,6,244,2,144,77,227,2,151,155,223,2,0,0,146,146,170,85,85,85,74,170,82,165,21,85,85,85,42,170,170,169,41,12,148,149,82,170,170,170,85,82,74,148,85,85,85,85,85,74,170,170,144,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [23,1,6,124,35,18,17,223,2,175,1,238,2,22,6,248,2,148,77,226,2,155,155,225,2,0,0,146,146,169,42,170,170,165,85,41,82,138,170,170,170,149,85,85,85,73,12,148,149,73,85,85,85,42,169,37,74,42,170,170,170,170,165,85,82,164,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [23,1,6,170,35,20,17,223,2,175,1,236,2,15,6,250,2,147,77,228,2,152,155,227,2,0,0,146,146,170,149,85,85,74,170,82,165,21,85,85,85,42,170,170,169,73,12,148,149,84,170,170,170,85,82,74,148,85,85,85,85,85,74,170,169,72,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [23,1,6,224,2,178,1,235,2,16,6,128,35,25,17,244,2,146,77,227,2,154,155,234,2,0,0,43,94,223,254,253,187,31,255,223,255,213,9,90,246,255,247,234,236,127,255,253,254,180,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [23,1,6,224,2,163,1,233,2,26,6,125,35,18,17,245,2,142,77,225,2,159,155,225,2,0,0,43,95,95,254,253,187,31,255,223,255,170,132,173,125,127,251,245,118,63,255,254,255,212,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [23,1,6,223,2,163,1,249,2,9,6,158,35,251,16,242,2,140,77,247,2,134,155,225,2,0,0,43,94,175,255,126,221,143,255,239,255,252,37,107,213,255,239,213,216,255,255,251,253,168,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [23,1,6,129,35,15,17,223,2,178,1,236,2,26,6,242,2,137,77,244,2,155,155,225,2,0,0,146,146,170,165,85,85,74,170,82,165,21,85,85,85,42,170,170,169,84,50,82,85,84,170,170,169,85,73,42,81,85,85,85,85,85,42,170,164,144,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [23,1,6,136,35,17,17,225,2,178,1,239,2,13,6,247,2,108,77,245,2,169,155,245,2,0,0,146,146,169,82,170,170,165,85,41,82,138,170,170,170,149,85,85,85,42,25,41,42,149,42,170,170,85,82,74,148,85,85,85,85,85,74,170,164,146,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [23,1,6,126,35,30,17,223,2,172,1,231,2,20,6,245,2,135,77,250,2,155,155,246,2,0,0,146,146,170,82,170,170,165,85,41,82,138,170,170,170,149,85,85,84,149,12,148,149,82,149,85,85,42,169,37,74,42,170,170,170,170,165,85,85,80,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [23,1,6,149,35,26,17,222,2,178,1,236,2,12,6,248,2,151,77,241,2,158,155,237,2,0,0,146,146,169,41,85,85,82,170,148,169,69,85,85,85,74,170,170,170,165,12,148,149,73,74,170,170,149,84,146,165,21,85,85,85,85,82,170,169,84,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [23,1,6,128,35,19,17,223,2,177,1,234,2,22,6,247,2,139,77,245,2,161,155,240,2,0,0,146,146,170,146,170,170,165,85,41,82,138,170,170,170,149,85,85,84,165,12,148,149,84,149,85,85,42,169,37,74,42,170,170,170,170,165,85,84,168,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [23,1,6,123,35,24,17,223,2,177,1,230,2,27,6,237,2,136,77,243,2,156,155,238,2,0,0,146,146,169,73,85,85,82,170,148,169,69,85,85,85,74,170,170,170,146,134,74,74,165,37,85,85,74,170,73,82,138,170,170,170,170,169,85,84,149,4],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [23,1,6,127,35,20,17,223,2,175,1,233,2,24,6,245,2,138,77,236,2,160,155,243,2,0,0,146,146,170,73,85,85,82,170,148,169,69,85,85,85,74,170,170,170,73,67,37,37,84,146,170,170,165,85,36,169,69,85,85,85,85,84,170,170,165,4],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [23,1,6,223,2,173,1,130,35,20,17,238,2,16,6,239,2,136,77,229,2,154,155,230,2,0,0,73,153,255,255,63,51,152,255,254,127,254,114,20,153,159,255,243,242,78,99,255,255,228,255,200,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [23,1,6,174,35,22,17,223,2,175,1,237,2,27,6,242,2,143,77,228,2,144,155,225,2,0,0,146,148,169,85,85,85,74,170,82,165,21,85,85,85,42,170,170,170,82,25,41,74,149,85,85,84,170,164,149,40,170,170,170,170,170,146,170,165,72,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [23,1,6,127,35,29,17,223,2,177,1,234,2,27,6,249,2,141,77,227,2,163,155,230,2,0,0,146,148,170,85,85,85,74,170,82,165,21,85,85,85,42,170,170,169,41,12,148,165,82,170,170,170,85,82,74,148,85,85,85,85,85,73,85,84,164,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [23,1,6,222,2,179,1,124,35,30,17,229,2,27,6,248,2,143,77,225,2,151,155,228,2,0,0,73,153,201,255,243,243,57,143,255,231,255,249,33,73,153,201,255,243,242,78,99,255,255,228,254,76,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [23,1,6,155,35,16,17,223,2,172,1,238,2,17,6,234,2,139,77,226,2,157,155,226,2,0,0,146,148,170,149,85,85,74,170,82,165,21,85,85,85,42,170,170,169,73,12,148,165,84,170,170,170,85,82,74,148,85,85,85,85,85,73,85,85,36,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [23,1,6,155,35,20,17,223,2,178,1,235,2,21,6,250,2,144,77,224,2,157,155,239,2,0,0,146,148,169,74,170,170,165,85,41,82,138,170,170,170,149,85,85,85,36,134,74,82,165,42,170,170,149,84,146,165,21,85,85,85,85,82,85,84,164,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [23,1,6,235,2,177,1,238,2,2,6,127,35,19,17,9,3,137,77,237,2,155,155,237,2,0,0,43,111,95,254,253,187,31,255,223,255,170,132,173,189,127,251,245,118,63,255,254,191,213,4],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [23,1,6,160,35,16,17,221,2,176,1,233,2,19,6,239,2,112,77,238,2,159,155,223,2,0,0,146,148,169,37,85,85,82,170,148,169,69,85,85,85,74,170,170,170,170,25,41,74,146,85,85,85,42,169,37,74,42,170,170,170,170,164,170,169,36,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [23,1,6,153,35,20,17,223,2,180,1,238,2,27,6,239,2,148,77,241,2,135,155,241,2,0,0,146,148,170,165,85,85,74,170,82,165,21,85,85,85,42,170,170,169,84,50,82,149,84,170,170,169,85,73,42,81,85,85,85,85,85,37,85,85,65,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [23,1,6,125,35,29,17,224,2,178,1,235,2,14,6,19,3,152,77,15,3,164,155,245,2,0,0,146,148,169,82,170,170,165,85,41,82,138,170,170,170,149,85,85,85,42,25,41,74,149,42,170,170,85,82,74,148,85,85,85,85,85,73,85,82,168,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [23,1,6,128,35,20,17,223,2,176,1,236,2,27,6,244,2,144,77,243,2,170,155,246,2,0,0,146,148,170,82,170,170,165,85,41,82,138,170,170,170,149,85,85,84,149,12,148,165,82,149,85,85,42,169,37,74,42,170,170,170,170,164,170,170,84,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [23,1,6,223,2,176,1,255,2,10,6,121,35,245,16,238,2,150,77,248,2,164,155,239,2,0,0,43,110,183,255,126,221,143,255,239,255,246,18,182,235,127,247,234,236,127,255,253,127,92,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [23,1,6,223,2,175,1,235,2,21,6,157,35,20,17,239,2,150,77,240,2,170,155,242,2,0,0,43,111,175,254,253,187,31,255,223,255,182,18,182,250,255,239,213,216,255,255,250,255,176,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [23,1,6,123,35,26,17,223,2,177,1,234,2,17,6,239,2,141,77,238,2,163,155,248,2,0,0,146,148,169,73,85,85,82,170,148,169,69,85,85,85,74,170,170,170,146,134,74,82,165,37,85,85,74,170,73,82,138,170,170,170,170,169,42,170,82,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [23,1,6,155,35,28,17,224,2,176,1,229,2,26,6,3,3,148,77,240,2,143,155,249,2,0,0,146,148,170,73,85,85,82,170,148,169,69,85,85,85,74,170,170,170,73,67,37,41,84,146,170,170,165,85,36,169,69,85,85,85,85,84,149,85,73,65,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,174,1,236,2,19,6,132,35,20,17,235,2,148,77,231,2,151,155,226,2,0,0,43,87,255,253,251,118,63,255,191,255,116,37,106,255,255,191,87,99,255,255,237,253,160,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,125,35,26,17,223,2,176,1,231,2,27,6,243,2,115,77,223,2,164,155,225,2,0,0,146,146,84,170,170,170,165,85,41,82,138,170,170,170,149,85,85,85,41,12,148,146,165,85,85,85,42,169,37,74,42,170,170,170,170,165,42,169,41,4],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,185,35,20,17,223,2,175,1,235,2,14,6,241,2,138,77,236,2,125,155,233,2,0,0,146,146,85,42,170,170,165,85,41,82,138,170,170,170,149,85,85,84,148,134,74,73,84,170,170,170,149,84,146,165,21,85,85,85,85,82,149,85,73,4],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,131,35,30,17,224,2,168,1,227,2,20,6,249,2,140,77,223,2,168,155,244,2,0,0,146,146,84,149,85,85,82,170,148,169,69,85,85,85,74,170,170,170,164,134,74,73,82,85,85,85,74,170,73,82,138,170,170,170,170,169,74,170,82,65,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,146,35,18,17,223,2,173,1,235,2,20,6,249,2,145,77,227,2,160,155,224,2,0,0,146,146,85,74,170,170,165,85,41,82,138,170,170,170,149,85,85,84,164,134,74,73,85,42,170,170,149,84,146,165,21,85,85,85,85,82,149,85,36,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,155,35,23,17,223,2,179,1,232,2,25,6,246,2,152,77,226,2,161,155,224,2,0,0,146,146,84,165,85,85,82,170,148,169,69,85,85,85,74,170,170,170,146,67,37,36,169,74,170,170,165,85,36,169,69,85,85,85,85,84,165,85,36,144,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,158,35,20,17,222,2,179,1,232,2,27,6,237,2,145,77,224,2,131,155,242,2,0,0,146,146,85,37,85,85,82,170,148,169,69,85,85,85,74,170,170,170,73,33,146,146,85,37,85,85,82,170,146,84,162,170,170,170,170,170,82,170,170,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,125,35,20,17,223,2,179,1,234,2,26,6,248,2,147,77,238,2,152,155,247,2,0,0,146,146,84,146,170,170,169,85,74,84,162,170,170,170,165,85,85,85,85,12,148,146,164,149,85,85,74,170,73,82,138,170,170,170,170,169,74,170,85,4],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,132,35,28,17,223,2,177,1,231,2,19,6,240,2,145,77,241,2,171,155,245,2,0,0,146,146,85,82,170,170,165,85,41,82,138,170,170,170,149,85,85,84,170,25,41,37,85,42,170,170,85,82,74,148,85,85,85,85,85,74,85,84,168,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,181,1,149,35,23,17,234,2,26,6,241,2,142,77,244,2,165,155,245,2,0,0,73,146,115,159,252,252,206,99,255,249,255,252,225,73,146,115,159,252,252,147,152,255,255,249,159,147,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,132,35,20,17,222,2,180,1,235,2,28,6,230,2,142,77,244,2,167,155,243,2,0,0,146,146,85,41,85,85,82,170,148,169,69,85,85,85,74,170,170,170,74,134,74,73,84,165,85,85,74,170,73,82,138,170,170,170,170,169,74,170,165,4],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,223,2,177,1,134,35,28,17,232,2,26,6,242,2,140,77,236,2,166,155,248,2,0,0,73,146,114,103,255,63,51,152,255,254,127,255,152,82,100,156,153,255,207,201,57,143,255,255,153,249,152,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,158,35,21,17,223,2,179,1,234,2,28,6,243,2,147,77,223,2,163,155,243,2,0,0,146,146,85,73,85,85,82,170,148,169,69,85,85,85,74,170,170,170,82,134,74,73,85,37,85,85,74,170,73,82,138,170,170,170,170,169,74,170,146,130],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,154,35,30,17,223,2,177,1,226,2,26,6,244,2,148,77,245,2,155,155,244,2,0,0,146,146,84,164,170,170,169,85,74,84,162,170,170,170,165,85,85,85,73,67,37,36,169,73,85,85,82,170,146,84,162,170,170,170,170,170,82,170,146,80,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [23,1,6,153,35,19,17,221,2,178,1,233,2,25,6,238,2,155,77,245,2,163,155,228,2,0,0,146,146,85,36,170,170,169,85,74,84,162,170,170,170,165,85,85,85,36,161,146,146,85,36,170,170,169,85,73,42,81,85,85,85,85,85,41,85,85,32,128],
    },
    ]
};

export default SHARP_YACIFBI
